module.exports = __webpack_public_path__ + "static/media/mosaic-desktop.830de664.jpg";